import type { ChangelogEntry } from "../types";

/**
 * VIB-2778. Verktøylinja i dokumenteditoren.
 *
 * Ingen rollekrav: alle som har skrivetilgang til en mappe i dokumentarkivet
 * møter editoren, og feilen traff det aller første man gjør i den.
 */
export const VERKTOYLINJE_2026_10: ChangelogEntry = {
  id: "2026-10-05-verktoylinje",
  date: "2026-10-05",
  title: "Formateringsknappene i dokumenteditoren står der de skal",
  summary:
    "Verktøylinja la seg i hjørnet av skjermen, oppå menyen, med begge adressefeltene åpne. Nå kommer den fram over teksten du skriver i.",
  sections: [
    {
      heading: "Dokumentarkiv",
      items: [
        {
          title: "Verktøylinja legger seg over teksten, ikke i hjørnet",
          kind: "rettet",
          body: "Begynte du på et nytt, tomt dokument, havnet formateringsknappene øverst til venstre på skjermen og dekket menyen. Nå kommer de fram rett over der du skriver. Er det ikke plass over, legger de seg under, og står du nær høyre kant, flyttes de innenfor så hele linja er synlig.",
        },
        {
          title: "Bare ett adressefelt om gangen",
          kind: "rettet",
          body: "Feltet for lenke og feltet for video kunne stå åpne samtidig, rett over hverandre. Nå lukkes det ene når du åpner det andre.",
        },
      ],
    },
  ],
};
